import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckoutMyPackageComponent } from './my-package.component';


import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';

import { PackageModule } from '../../shared/components/package/package.module';
import { PackageHelperModule } from '../../shared/components/package-helper/package-helper.module';
import { ProductModule } from "../../shared/components/product/product.module";

import { MatCardModule } from '@angular/material/card';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    MatCardModule,
    MatDividerModule,
    MatIconModule,
    PackageModule,
    PackageHelperModule,
    
    ProductModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [
    CheckoutMyPackageComponent
  ],
  providers: [],
  declarations: [
    CheckoutMyPackageComponent
  ]
})
export class CheckoutMyPackageModule { }
